
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import gateway from "@/lib/request/gateway";
import { NRCandidate } from "@/lib/model/NRXQ/candidate";
import { AtsCompany, NRClientType } from "@/lib/model/NRXQ/nr";
import Template from "@/views/ai-builder/components/template.vue";
import { ElForm } from "element-ui/types/form";

@Component({
  components: { Template }
})
export default class TableDemo extends Vue {
  @Prop({ default: true, type: Boolean }) showBar!: boolean; //是否展示进度条
  // @Prop({ default: true, type: Boolean }) beforeCheck!: boolean; //上传前 校验结果
  @Prop({ default: null, type: Function }) beforeUploadCheck!: Function; //上传前 校验结果
  @Prop({ default: "", type: String }) textTip!: string; //提示文案
  @Prop({ type: String, default: NRClientType.NRClientTypeAdmin })
  clientType!: string;
  loading = false;
  percent = 0;
  uploadedFileNumber = 0;
  totalFileNumber = 0;
  failedFileNumber = 0;
  dialogVisible = true;
  cvList: any[] = [];
  showCancelDialog = false;
  form: any = {};
  atsCompanyList?: AtsCompany[] = [];
  fileNameList: any = []; //所有文件名状态list
  failedFileList: any = [];
  showSelectCompany = false;
  formRules: any = {};

  positionTypeList = [
    {
      name: "主播",
      value: 1
    },
    {
      name: "编导",
      value: 2
    },
    {
      name: "直播运营",
      value: 3
    }
  ];

  get token() {
    return Auth.token;
  }

  async created() {
    this.showSelectCompany = this.clientType == NRClientType.NRClientTypeAdmin;
    if (this.showSelectCompany) {
      this.formRules = {
        atsCompanyId: [
          { required: true, message: "请选择应聘公司", trigger: "change" }
        ],
        position: [
          { required: true, message: "请输入应聘岗位", trigger: "change" }
        ],
        positionType: [
          { required: true, message: "请选择职位类型", trigger: "change" }
        ]
      };
      this.atsCompanyList = await AtsCompany.getCompanyList();
    } else {
      this.formRules = {
        position: [
          { required: true, message: "请输入应聘岗位", trigger: "blur" }
        ]
      };
    }
  }

  @Emit()
  close() {
    (this.$refs.upload as any).abort();
  }

  mounted() {
    this.uploadedFileNumber = 0;
    this.totalFileNumber = 0;
    this.showCancelDialog = false;
  }

  onExceed(files: any, fileList: any) {
    this.$message.error("文件数量超出限制");
  }

  //上传前 校验
  beforeUpload(file: File) {
    if (this.beforeUploadCheck && !this.beforeUploadCheck(file)) {
      return false;
    }

    const isLt500M = file.size / 1024 / 1024 < 500;
    if (!isLt500M) {
      this.$message.error("文件过大!");
      return false;
    }

    this.totalFileNumber++;
    //检查格式
    if (this.checkFileType(file.name)) {
      this.fileNameList.push({ name: file.name, status: "上传中" });
    } else {
      this.$message.warning("【" + file?.name + "】格式不支持");
      this.fileNameList.push({ name: file.name, status: "上传失败" });
      this.failedFileNumber++;
      return false;
    }
  }
  upload(data: { filename: string; file: File }) {
    const { filename, file } = data;
    this.loading = true;
    //获取上传凭证
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        // const tempUrl = postRes.cdn + "/" + postRes.dir;
        // postRes.cdn = "https://oss.hina.com"; //测试证书过期 用线上的
        // 上传到oss
        const config: any = {
          onUploadProgress: (progressEvent: any) => {
            //progressEvent.loaded:已上传文件大小
            //progressEvent.total:被上传文件的总大小
            this.percent = this.computePer(
              progressEvent.loaded,
              progressEvent.total
            );
          }
        };

        gateway
          .upload(postRes, file, config)
          .then((res: any) => {
            console.log("upload res : ", res);
            this.parseCv(res);
          })
          .catch((res: any) => {
            this.failedFileNumber++;
            this.failedFileList.push(file.name);
            this.fileNameList.forEach((d: any) => {
              if (d.name === file.name) {
                d.status = "上传失败";
              }
            });
          })
          .finally(() => {
            // this.imageUrl = tempUrl;
            // this.$emit("change", this.imageUrl);
          });
      }
    });
  }

  //上传成功解析文件
  async parseCv(res: any) {
    try {
      const cv = await NRCandidate.parse(
        res.object,
        res.filename,
        this.clientType
      );
      this.cvList.push(cv);
    } catch (e) {
      console.log(e);
    }
    this.uploadedFileNumber++;
    console.warn(this.fileNameList);
    this.fileNameList.forEach((d: any) => {
      if (d.name === res.filename) {
        d.status = "上传成功";
      }
    });
    console.log(this.cvList);
  }
  save() {
    (this.$refs.form as ElForm).validate(valid => {
      if (valid) {
        NRCandidate.mcreate(this.clientType, this.cvList, this.form)
          .then((res: any) => {
            console.log(res);
            this.$message.success("保存成功");
            this.close();
          })
          .catch((e: any) => {
            console.log(e);
          });
      }
    });
  }
  cancel() {
    if (this.totalFileNumber > 0) {
      this.showCancelDialog = true;
    } else {
      this.close();
    }
  }
  beforeRemove(file: any, fileList: any) {
    return false;
  }
  computePer(i: number, ii: number) {
    const p = Number((Number(i) / Number(ii)).toFixed(3)) * 100;
    const t = String(p).split(".")[0];
    return Number(t);
  }
  onProgress(event: any, file: any, fileList: any) {
    console.log(event);
  }
  //区分文件类型
  checkFileType(name: string) {
    if (
      [
        "pdf",
        "PDF",
        "png",
        "PNG",
        "jpg",
        "JPG",
        "DOC",
        "doc",
        "txt",
        "TXT"
      ].includes(name.slice(-3)) ||
      ["docx", "DOCX"].includes(name.slice(-4))
    ) {
      return true;
    } else {
      return false;
    }
  }
}
